import _Button from "@material-ui/core/esm/Button";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import { CSSTransition } from 'react-transition-group';
import classnames from 'classnames';
import productDetailsClasses from 'swag-client-common/styles/product-details.scss';
import InfoDialog from 'swag-client-common/components/info/info-dialog';
import { LOGO_UPLOAD_BLANK_OPTIONS } from 'swag-common/constants/product.constants';
import { ProductInformation } from '../product-information';
import { ChooseColor } from '../choose-color';
import { QuantityBlockMultiple } from '../quantity-block-multiple';
import appearAnimClasses from '../../../../../../animations/appear-with-height.anim.scss';
import { DEFAULT_BUTTON } from '../../../../../../constants/styles';
import { EmbellishmentMethodTooltip } from '../embellishment-method/embellishment-method-tooltip';
import OutOfStock from '../out-of-stock';
import { EmbellishmentChangeProductionTimeConfirmationPopup } from '../../../../../popups/embellishment-change-production-time-confirmation-popup';
import { EmbellishmentChangeLocationConfirmationPopup } from '../../../../../popups/embellishment-change-location-confirmation-popup';
import SwitchButton from './components/switch-button/switch-button';
import ProductDetailsNumber from './components/product-details-number';
import CustomizeBlank from './components/customize-blank';
import DiscountInfoDialog from './components/discount-info-dialog';
import { PriceBlock } from './components/price-block';
import Footer from './components/footer';
import { AssociatedProductIcon } from './components/associated-product-icon';
import STYLES from './details-styles';
import CSSclasses from './details.scss';
import { SwitchEmbellishmentMethodButton } from './components';
import { UploadLogos } from './components/upload-logos';
const designNoteDialogContent = `
      Leave any additional design feedback here. <br />
      We are going to have our production facility take a look at your mockup and any design notes you have and create a production mockup. <br />
      You will receive this production mockup within 48 hours after you place your order. <br />
      If we are using embroidery to embellish your design, you will receive a sewout of your design. This may take up to a week. <br />
      Don't worry, we will not go into production until you have first approved the production mockup. <br />
    `;
export const styles = {
  button: _objectSpread({
    DEFAULT_BUTTON
  }, STYLES.button),
  templateButton: _objectSpread({}, DEFAULT_BUTTON, STYLES.templateButton, {
    padding: '11px 46px'
  })
};
export class DetailsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sizesDialogOpened: false,
      designNoteDialogOpened: false,
      discountInfoDialogOpened: false
    };
    this.handleDesignNotesChange = this.handleDesignNotesChange.bind(this);
    this.handleRelatedProductAdd = this.handleRelatedProductAdd.bind(this);
  }
  componentWillUnmount() {
    this.props.resetInventoryId();
  }
  onToggleDiscountInfoDialog({
    isOpened
  }) {
    this.setState({
      discountInfoDialogOpened: isOpened
    });
  }
  handleDesignNotesChange(e) {
    const {
      onDesignNotesChange
    } = this.props;
    const {
      value
    } = e.target;
    if (value.length <= 500) {
      onDesignNotesChange(value);
    }
  }
  handleRelatedProductAdd(event) {
    event.preventDefault();
    const {
      product,
      isThereNotSelectedRelatedProduct,
      onChangeRelatedProductsPopupVisibility
    } = this.props;
    const products = isThereNotSelectedRelatedProduct ? product.associatedProducts : null;
    onChangeRelatedProductsPopupVisibility(products);
  }
  render() {
    const {
      product: {
        _id: productId,
        colored,
        sizeDependentPrice,
        hasSize,
        swagLogoDiscount,
        locationPrintTitle,
        logoUploadBlankOption
      },
      embellishmentMethods,
      embellishmentMethod,
      productVariantsToChoose,
      showColorSection,
      showEmbellishmentMethodSection,
      sizeOptions,
      isOutOfStock,
      outOfStockDate,
      designNotes,
      sizeLoaded,
      discount,
      onDiscountChange,
      onVariantChange,
      onSizeIndexChange,
      isFullDesignProduct,
      selectedAssociatedProducts,
      openRelatedProductBuilder,
      removeRelatedProduct,
      isLimitedEdition,
      isLoggedIn,
      classes,
      shouldDisplayRelatedProductsBlock,
      shouldDisplayUploadLogos,
      shouldDisplayDesignNotes,
      shouldDisplayQuantityBlock,
      totalOfAssociatedPrice,
      isCuratedBrandStore,
      chooseMethodProductDetailsBlockHeader
    } = this.props;
    const chooseSize = number => /*#__PURE__*/React.createElement("div", {
      className: productDetailsClasses.block,
      "data-block": "MainProductSize"
    }, /*#__PURE__*/React.createElement("h5", {
      className: productDetailsClasses.blockTitle
    }, /*#__PURE__*/React.createElement(ProductDetailsNumber, {
      number: number
    }), "Choose size"), /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.fullRow
    }, sizeOptions.map(({
      option,
      isActive,
      isActiveLE,
      isDisabled
    }, i) => /*#__PURE__*/React.createElement(SwitchButton, {
      key: i,
      "data-size": i,
      onClick: () => onSizeIndexChange(i),
      isActive: isActive,
      className: isActiveLE ? CSSclasses.limitedEditionBtn : '',
      disabled: isDisabled
    }, option))));
    const chooseEmbellishmentMethod = number => /*#__PURE__*/React.createElement("div", {
      className: classnames(productDetailsClasses.block, productDetailsClasses.blockOverflowHidden, CSSclasses.chooseDecoratingBlockHolder),
      "data-block": "MainProductDecorating"
    }, /*#__PURE__*/React.createElement("h5", {
      className: productDetailsClasses.blockTitle
    }, /*#__PURE__*/React.createElement(ProductDetailsNumber, {
      number: number
    }), chooseMethodProductDetailsBlockHeader), /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.fullRow
    }, embellishmentMethods.map(method => /*#__PURE__*/React.createElement(SwitchEmbellishmentMethodButton, {
      key: method.name,
      method: method,
      productId: productId
    }))), /*#__PURE__*/React.createElement(EmbellishmentMethodTooltip, {
      embellishmentMethod: embellishmentMethod
    }));
    const chooseVariant = number => /*#__PURE__*/React.createElement("div", {
      className: productDetailsClasses.block
    }, /*#__PURE__*/React.createElement("h5", {
      className: productDetailsClasses.blockTitle
    }, /*#__PURE__*/React.createElement(ProductDetailsNumber, {
      number: number
    }), "Choose type"), /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.typeButtonsWrapper
    }, productVariantsToChoose.map((_ref, i) => {
      let {
          isActive,
          isActiveLE,
          isDisabled
        } = _ref,
        productVariant = _objectWithoutProperties(_ref, ["isActive", "isActiveLE", "isDisabled"]);
      return /*#__PURE__*/React.createElement(SwitchButton, {
        key: i,
        onClick: () => onVariantChange(i),
        isActive: isActive,
        disabled: isDisabled,
        className: isActiveLE ? CSSclasses.limitedEditionBtn : ''
      }, productVariant.name);
    })));
    const designNotesBlock = number => /*#__PURE__*/React.createElement("div", {
      className: classnames(productDetailsClasses.block, productDetailsClasses.blockOverflowHidden)
    }, /*#__PURE__*/React.createElement("h5", {
      className: productDetailsClasses.blockTitle
    }, /*#__PURE__*/React.createElement(ProductDetailsNumber, {
      number: number
    }), locationPrintTitle, /*#__PURE__*/React.createElement("span", {
      className: productDetailsClasses.subHeader
    }, " (Optional)"), /*#__PURE__*/React.createElement("span", {
      className: productDetailsClasses.info,
      onClick: () => this.setState({
        designNoteDialogOpened: true
      })
    }, "\xA0")), /*#__PURE__*/React.createElement("textarea", {
      "data-input": "AdditionalText",
      rows: 2,
      name: "designNote",
      maxLength: 500,
      value: designNotes,
      onChange: this.handleDesignNotesChange
    }));
    const discountBlock = number => /*#__PURE__*/React.createElement("div", {
      className: productDetailsClasses.block
    }, /*#__PURE__*/React.createElement("h5", {
      className: productDetailsClasses.blockTitle
    }, /*#__PURE__*/React.createElement(ProductDetailsNumber, {
      number: number
    }), "10% Discount (Optional)", /*#__PURE__*/React.createElement("span", {
      onClick: () => this.onToggleDiscountInfoDialog({
        isOpened: true
      })
    }, "\xA0")), /*#__PURE__*/React.createElement("button", {
      onClick: onDiscountChange,
      className: classnames(CSSclasses.discountButton, discount ? CSSclasses.active : '')
    }, "Yes, please"));
    const relatedProductsBlock = number => /*#__PURE__*/React.createElement("div", {
      id: "relatedProductBlock",
      className: classnames(productDetailsClasses.block, CSSclasses.onlyDesktop)
    }, /*#__PURE__*/React.createElement("h5", {
      className: productDetailsClasses.blockTitle
    }, /*#__PURE__*/React.createElement(ProductDetailsNumber, {
      number: number
    }), "Add related products (Optional)"), /*#__PURE__*/React.createElement("p", null, "Click the Add Products button below, and add products to the order that will have the same print design, to save on printing costs"), /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.associatedList
    }, /*#__PURE__*/React.createElement(_Button, {
      onClick: this.handleRelatedProductAdd,
      variant: "contained",
      className: classnames(classes.button, CSSclasses.buttonWithoutMargin, CSSclasses.button),
      "data-button": "AddAssociated"
    }, "+ Add Products"), /*#__PURE__*/React.createElement("div", {
      className: CSSclasses.displayFlex
    }, selectedAssociatedProducts.map(item => /*#__PURE__*/React.createElement(AssociatedProductIcon, {
      item: item,
      key: item.product._id,
      onProductClick: openRelatedProductBuilder,
      onProductRemoveClick: removeRelatedProduct
    })))));
    let blockCounter = 0;
    const renderDetails = isOutOfStock => isOutOfStock ? /*#__PURE__*/React.createElement(OutOfStock, {
      productId: productId,
      outOfStockDate: outOfStockDate
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, !isCuratedBrandStore && logoUploadBlankOption === LOGO_UPLOAD_BLANK_OPTIONS.BLANK_AND_PRINTED && /*#__PURE__*/React.createElement(CustomizeBlank, {
      number: blockCounter += 1
    }), sizeDependentPrice ? /*#__PURE__*/React.createElement("div", null, !colored && !isFullDesignProduct && chooseVariant(blockCounter += 1), !!hasSize && !!sizeLoaded && chooseSize(blockCounter += 1), !!colored && showColorSection && /*#__PURE__*/React.createElement(ChooseColor, {
      number: blockCounter += 1
    }), /*#__PURE__*/React.createElement(CSSTransition, {
      classNames: appearAnimClasses,
      in: showEmbellishmentMethodSection,
      unmountOnExit: true,
      timeout: 200
    }, chooseEmbellishmentMethod(showEmbellishmentMethodSection ? blockCounter += 1 : blockCounter + 1)), /*#__PURE__*/React.createElement(CSSTransition, {
      classNames: appearAnimClasses,
      in: shouldDisplayUploadLogos,
      unmountOnExit: true,
      timeout: 200
    }, /*#__PURE__*/React.createElement(UploadLogos, {
      number: shouldDisplayUploadLogos ? blockCounter += 1 : blockCounter + 1,
      classes: classes
    })), shouldDisplayQuantityBlock && /*#__PURE__*/React.createElement("div", {
      className: productDetailsClasses.block
    }, /*#__PURE__*/React.createElement(QuantityBlockMultiple, {
      number: blockCounter += 1,
      isLimitedEdition: !!isLimitedEdition,
      isLoggedIn: isLoggedIn
    })), /*#__PURE__*/React.createElement(CSSTransition, {
      classNames: appearAnimClasses,
      in: shouldDisplayDesignNotes,
      unmountOnExit: true,
      timeout: 200
    }, designNotesBlock(shouldDisplayDesignNotes ? blockCounter += 1 : blockCounter + 1)), !!swagLogoDiscount && discountBlock(blockCounter += 1), shouldDisplayRelatedProductsBlock && relatedProductsBlock(blockCounter += 1)) : /*#__PURE__*/React.createElement("div", null, !isFullDesignProduct && (colored ? showColorSection && /*#__PURE__*/React.createElement(ChooseColor, {
      number: blockCounter += 1
    }) : chooseVariant(blockCounter += 1)), /*#__PURE__*/React.createElement(CSSTransition, {
      classNames: appearAnimClasses,
      in: showEmbellishmentMethodSection,
      unmountOnExit: true,
      timeout: 200
    }, chooseEmbellishmentMethod(showEmbellishmentMethodSection ? blockCounter += 1 : blockCounter + 1)), /*#__PURE__*/React.createElement(CSSTransition, {
      classNames: appearAnimClasses,
      in: shouldDisplayUploadLogos,
      unmountOnExit: true,
      timeout: 200
    }, /*#__PURE__*/React.createElement(UploadLogos, {
      number: shouldDisplayUploadLogos ? blockCounter += 1 : blockCounter + 1,
      classes: classes
    })), shouldDisplayQuantityBlock && /*#__PURE__*/React.createElement("div", {
      className: productDetailsClasses.block
    }, /*#__PURE__*/React.createElement(QuantityBlockMultiple, {
      number: blockCounter += 1,
      isLimitedEdition: !!isLimitedEdition,
      isLoggedIn: isLoggedIn
    })), /*#__PURE__*/React.createElement(CSSTransition, {
      classNames: appearAnimClasses,
      in: shouldDisplayDesignNotes,
      unmountOnExit: true,
      timeout: 200
    }, designNotesBlock(shouldDisplayDesignNotes ? blockCounter += 1 : blockCounter + 1)), !!swagLogoDiscount && discountBlock(blockCounter += 1), shouldDisplayRelatedProductsBlock && relatedProductsBlock(blockCounter += 1)));
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(CSSclasses.details, {
        [CSSclasses.isOutOfStock]: isOutOfStock
      }),
      id: "details"
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(productDetailsClasses.block, productDetailsClasses.onlyDesktop)
    }, /*#__PURE__*/React.createElement(ProductInformation, null)), renderDetails(isOutOfStock), /*#__PURE__*/React.createElement(Footer, {
      totalOfAssociatedPrice: totalOfAssociatedPrice,
      PriceBlock: PriceBlock
    }), /*#__PURE__*/React.createElement(InfoDialog, {
      subHeader: "additional info",
      header: "Your design notes",
      content: designNoteDialogContent,
      setInnerHTML: true,
      onRequestClose: () => {
        this.setState({
          designNoteDialogOpened: false
        });
      },
      open: this.state.designNoteDialogOpened
    }), /*#__PURE__*/React.createElement(DiscountInfoDialog, {
      open: this.state.discountInfoDialogOpened,
      onRequestClose: () => this.onToggleDiscountInfoDialog({
        isOpened: false
      })
    }), /*#__PURE__*/React.createElement(EmbellishmentChangeProductionTimeConfirmationPopup, null), /*#__PURE__*/React.createElement(EmbellishmentChangeLocationConfirmationPopup, null));
  }
}